import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { useScrollableWires } from './common/scrollable-wires-hooks';
import Tail from './common/wires-list-tail';
import commonProps from './common/common-props';
import { useGetPaginatedWiresFromContributor } from '../../../services/wires/from-contributor-service';
import Wire from './common/wire';

export default function MyPublishedWires({ profileId }) {
  const common = commonProps();
  const {
    wires, infiniteRef, expandList, showExpand, hasMore,
  } = useScrollableWires({ useGetWires: () => useGetPaginatedWiresFromContributor(profileId) });

  return (
    <ThemeProvider theme={common}>
      <>
        <article>
          {wires.map(wire => <Wire key={`my-published-wire-${wire.id}`} wire={wire} />)}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all wires</button></Tail>
          )}
          {!hasMore && <Tail><span>You have seen all the results</span></Tail>}
        </article>
      </>
    </ThemeProvider>
  );
}

MyPublishedWires.propTypes = {
  profileId: PropTypes.number.isRequired,
};
